import React from 'react';
import CustomList from '../CustomList/CustomList';
import { Box, Typography } from '@mui/material';
import { ReactComponent as VideoIcon } from 'src/common/images/video.svg';
import { SmartImage } from '@cellebrite/saas-ui-common';

interface CustomMultiMediaViewProps {
    media: any;
    roundedCorners?: boolean;
    roundedBottomCorners?: boolean;
    elementInImage?: any;
}

const AMOUNT = {
    ONE: 1,
    TWO: 2,
    THREE: 3,
    FOUR: 4,
};

const CustomMultiMediaView: React.FC<CustomMultiMediaViewProps> = ({
    media,
    roundedCorners,
    roundedBottomCorners,
    elementInImage,
}) => {
    const mediaOriginal = media;
    if (media.length > AMOUNT.FOUR) {
        media = media.slice(0, AMOUNT.FOUR);
    }
    let containerStyles;
    const halfMinusGapSizeStyle = 'calc(50% - 4px)';
    const fullSizeStyle = '100%';
    switch (media.length) {
        case AMOUNT.ONE:
            containerStyles = { width: fullSizeStyle, height: fullSizeStyle };
            break;
        case AMOUNT.TWO:
            containerStyles = { width: halfMinusGapSizeStyle, height: fullSizeStyle };
            break;
        case AMOUNT.THREE:
        case AMOUNT.FOUR:
        default:
            containerStyles = { width: halfMinusGapSizeStyle, height: halfMinusGapSizeStyle };
    }

    return (
        <CustomList
            elementInImage={elementInImage}
            styles={{
                borderRadius: `${roundedCorners ? 8 : 0}px`,
                borderBottomLeftRadius: `${roundedCorners || roundedBottomCorners ? 8 : 0}px`,
                borderBottomRightRadius: `${roundedCorners || roundedBottomCorners ? 8 : 0}px`,
                overflow: 'hidden',
                width: '100%',
                height: '100%',
                flexDirection: media.length === AMOUNT.THREE ? 'column' : null,
            }}
            list={media.map((part, index) => (
                <SmartImage
                    key={index}
                    containerStyles={
                        index + 1 === AMOUNT.THREE
                            ? { width: halfMinusGapSizeStyle, height: fullSizeStyle }
                            : containerStyles
                    }
                    cover={true}
                    src={part.url}
                    centerOverlay={
                        part.type === 'Video' ? (
                            <Box
                                style={{
                                    borderRadius: 50,
                                    width: 86,
                                    height: 86,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                                className="fill-l background-color-bd-opacity"
                            >
                                <VideoIcon />
                            </Box>
                        ) : mediaOriginal.length > 4 && index === 3 ? (
                            <Typography variant="s24w500" className="color-l">
                                +{mediaOriginal.length - 4}
                            </Typography>
                        ) : null
                    }
                />
            ))}
            gap={{ width: 1, height: 1 }}
        />
    );
};

export default CustomMultiMediaView;
